import * as React from 'react';
import { useMappedState } from 'redux-react-hook';
import { useCallback } from 'react';
import { DirectoryStoreState } from '../../types';
import { ExtensionItem } from '../ExtensionItem';
import { getFilteredExtensions } from '../../reducers/extensions';
import { ExtensionsSearchBar } from '../ExtensionsSearchBar';

export interface ExtensionsListProps {
  storeId: number;
  sloc: string;
  number: string;
}

export const ExtensionsList: React.FC<ExtensionsListProps> = ({ storeId, sloc, number }) => {
  const { extensionsCount, isExtensions, isOpen, isIntegrationUrl } = useMappedState(
    useCallback(
      (state: DirectoryStoreState) => ({
        extensionsCount: state.extensions[storeId]
          ? getFilteredExtensions(storeId)(state).length
          : 0,
        isExtensions: state.extensions[storeId] ? !!state.extensions[storeId].index.length : 0,
        isOpen: state.extensions[storeId] ? state.extensions[storeId].isOpen : false,
        isIntegrationUrl: !!state.queryString.integrationURL,
      }),
      [storeId]
    )
  );

  return isOpen ? (
    <div className="extensions">
      {isExtensions ? (
        <React.Fragment>
          <ExtensionsSearchBar storeId={storeId} />
          {extensionsCount
            ? new Array(extensionsCount)
                .fill(null)
                .map((_, index) => (
                  <ExtensionItem
                    index={index}
                    key={index}
                    storeId={storeId}
                    sloc={sloc}
                    number={number}
                    isIntegrationUrl={isIntegrationUrl}
                  />
                ))
            : 'No Results'}
        </React.Fragment>
      ) : (
        'No Extensions'
      )}
    </div>
  ) : null;
};
